import { __assign } from "tslib";
import { mapSchema, MapperKind } from '@graphql-tools/utils';
import { decorateWithLogger } from './decorateWithLogger';
export function addErrorLoggingToSchema(schema, logger) {
    var _a;
    if (!logger) {
        throw new Error('Must provide a logger');
    }
    if (typeof logger.log !== 'function') {
        throw new Error('Logger.log must be a function');
    }
    return mapSchema(schema, (_a = {},
        _a[MapperKind.OBJECT_FIELD] = function (fieldConfig, fieldName, typeName) { return (__assign(__assign({}, fieldConfig), { resolve: decorateWithLogger(fieldConfig.resolve, logger, typeName + "." + fieldName) })); },
        _a));
}
//# sourceMappingURL=addErrorLoggingToSchema.js.map